import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { RenewalRatingResponse } from '@acorn-portal/shared/src/services/renewalsApi';
import { formatCurrency } from '@acorn-portal/shared/src/utils';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';

interface IComplianceFinanceWording {
	rate: RenewalRatingResponse | null;
	deposit: boolean | undefined;
}

const ComplianceFinanceWording: FC<IComplianceFinanceWording> = ({ rate, deposit }) => {
	const policy = useAppSelector((state) => state.fullPolicy);
	const financedPolicy = import.meta.env.VITE_AUTH_REALM !== 'Motorcade';
	if (!rate) return null;

	return (
		<>
			<Box sx={{ px: { md: 6 }, textAlign: 'left' }}>
				<Typography sx={{ mt: 4, fontSize: 24, fontWeight: 'bold' }}>Payment Details</Typography>
			</Box>
			<Box sx={{ px: { md: 6 } }}>
				{financedPolicy && (
					<>
						<Box sx={{ borderBottom: 1, borderColor: 'gray.300', py: 2 }}>
							<Typography>
								Total cost of policy <strong>without</strong> premium finance (Pay Annually) ={' '}
								<strong>{formatCurrency(rate.annualPremium)}</strong>
							</Typography>
						</Box>
						<Box sx={{ borderBottom: 1, borderColor: 'gray.300', py: 2 }}>
							<Typography>
								Total cost of policy <strong>with</strong> premium finance (Pay Monthly) ={' '}
								<strong>
									{formatCurrency(
										deposit
											? (rate.financePlanWithDeposit?.totalPremium as number)
											: (rate.financePlanWithoutDeposit?.totalPremium as number),
									)}
								</strong>{' '}
								<br />
								<strong>Difference in cost:</strong> monthly payments using premium finance cost{' '}
								<strong>
									{formatCurrency(
										deposit
											? (rate.financePlanWithDeposit?.chargeForCredit as number)
											: (rate.financePlanWithoutDeposit?.chargeForCredit as number),
									)}
								</strong>{' '}
								more than to make one payment in full today.
							</Typography>
						</Box>
						<Box sx={{ borderBottom: 1, borderColor: 'gray.300', py: 2 }}>
							<Typography>
								Please note - financing your insurance policy premium on a monthly basis using premium finance is more
								expensive than paying for your annual premium in full now.
							</Typography>
						</Box>
					</>
				)}
				<Box sx={{ borderBottom: 1, borderColor: 'gray.300', py: 2 }}>
					{policy.scheme === 'Acorn6MTX' ? (
						<Typography>
							Our policy duration is 6 months; however, your credit agreement has a duration of 5 months.
						</Typography>
					) : (
						<Typography>
							Our policy duration is 12 months; however, your credit agreement has a duration of 11 months.
						</Typography>
					)}
				</Box>
				<Box sx={{ borderBottom: 1, borderColor: 'gray.300', py: 2 }}>
					<Typography>
						Prices include Insurance Premium Tax of <strong>{rate.insurancePremiumTaxPercentage}%</strong> and a
						non-refundable Policy Administration fee of <strong>{formatCurrency(rate.policyAdministrationFee)}</strong>
					</Typography>
				</Box>
			</Box>
		</>
	);
};

export default ComplianceFinanceWording;
